module.exports = __webpack_public_path__ + "img/BOCA_COMPLETA.43780f9b.png";